import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { LoadRow } from "./LoadRow";
import { Checkbox } from "@/components/ui/checkbox";

const SortHeader = ({ label, k, sort, onSort }) => {
  const on = sort.key === k;
  const Icon = !on ? ArrowUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className="text-left px-4 py-3 font-medium">
      <button
        type="button"
        onClick={() => onSort(k)}
        className={`inline-flex items-center gap-1 uppercase tracking-wider hover:text-slate-900 ${on ? "text-slate-900" : ""}`}
        data-testid={`sort-${k}`}
      >
        {label} <Icon className="w-3.5 h-3.5" />
      </button>
    </th>
  );
};

const Th = ({ children }) => <th className="text-left px-4 py-3 font-medium">{children}</th>;

export const LoadsTable = ({ loads, loading, empty, sort, onSort, selectedIds, onSelectAll, ...rowProps }) => {
  const allOn = loads.length > 0 && loads.every((l) => selectedIds.has(l.id));
  const someOn = !allOn && loads.some((l) => selectedIds.has(l.id));
  return (
  <div className="overflow-x-auto">
    <table className="min-w-full text-sm">
      <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
        <tr>
          <th className="pl-4 pr-1 py-3 w-8" title="Select all shown loads">
            <Checkbox checked={allOn ? true : someOn ? "indeterminate" : false} disabled={!loads.length} onCheckedChange={() => onSelectAll(loads, !allOn)} aria-label="Select all shown loads" data-testid="select-all-loads" />
          </th>
          <Th>Load #</Th>
          <Th>Broker</Th>
          <Th>Route</Th>
          <Th>Driver</Th>
          <SortHeader label="Rate" k="rate" sort={sort} onSort={onSort} />
          <SortHeader label="Status" k="status" sort={sort} onSort={onSort} />
          <Th>Flags</Th>
          <SortHeader label="Created" k="created_at" sort={sort} onSort={onSort} />
          <th className="px-2 py-3" />
        </tr>
      </thead>
      <tbody>
        {loading && <tr><td colSpan={10} className="px-4 py-10 text-center text-slate-400">Loading…</td></tr>}
        {!loading && loads.length === 0 && (
          <tr><td colSpan={10} className="px-4 py-10 text-center text-slate-400" data-testid="loads-empty">{empty}</td></tr>
        )}
        {loads.map((l) => <LoadRow key={l.id} load={l} selected={selectedIds.has(l.id)} {...rowProps} />)}
      </tbody>
    </table>
  </div>
  );
};
